<template>
  <div id="privacy" class="body-container">
    <div class="body-content" v-show="isShow">
      <div class="title">1. 个人基本信息</div>
      <div class="sub-title">信息名称:</div>
      <div>电话号码</div>

      <div class="sub-title">收集目的:</div>
      <div>账号注册、登录使用成者云旗下软件</div>
      <div>保障用户安全,找回密码等服务</div>
      <div>账号丢失找回凭证</div>
      <div>提供客服和售后提供咨询服务</div>

      <div class="sub-title">使用场景：</div>
      <div>登录注册时</div>
      <div>默认的用户昵称</div>
      <div>与客服和售后咨询服务</div>

      <div class="sub-title">收集情况:</div>
      <div>收集1次</div>
      
      <div class="sub-title">信息名称:</div>
      <div>邮箱</div>

      <div class="sub-title">收集目的:</div>
      <div>可作为账号进行账号注册、登录、密码找回时</div>

      <div class="sub-title">使用场景：</div>
      <div>账号注册、登录、密码找回时</div>

      <div class="sub-title">收集情况:</div>
      <div>收集1次</div>

      <div class="title">2. 网络身份标识信息</div>
      <div class="sub-title">信息名称:</div>
      <div>账号及密码</div>

      <div class="sub-title">使用目的：</div>
      <div>创建账号</div>

      <div class="sub-title">使用场景：</div>
      <div>创建账号时</div>

      <div class="sub-title">收集情况：</div>
      <div>收集1次</div>

      <div class="sub-title">信息名称：</div>
      <div>昵称</div>

      <div class="sub-title">使用目的：</div>
      <div>完善账号信息；发布信息</div>

      <div class="sub-title">使用场景：</div>
      <div>会议开启或在通讯录进行展示</div>
      <div>生成文件的默认署名</div>

      <div class="sub-title">收集情况：</div>
      <div>收集1次</div>

      <div class="sub-title">信息名称：</div>
      <div>头像</div>

      <div class="sub-title">使用目的：</div>
      <div>完善账号信息；发布信息</div>

      <div class="sub-title">使用场景：</div>
      <div>会议开启时，或在通讯录进行展示</div>

      <div class="sub-title">收集情况：</div>
      <div>收集1次</div>

      <div class="sub-title">信息名称：</div>
      <div>第三方账号信息（头像、昵称）</div>

      <div class="sub-title">使用目的：</div>
      <div>第三方登录</div>

      <div class="sub-title">使用场景：</div>
      <div>使用第三方账号进行登录</div>

      <div class="sub-title">收集情况：</div>
      <div>收集1次</div>

      <div class="title">3. 个人常用设备信息</div>
      <div class="sub-title">信息名称：</div>
      <div>设备品牌</div>

      <div class="sub-title">使用目的：</div>
      <div>App质量保障</div>

      <div class="sub-title">使用场景：</div>
      <div>App启动与会议中针对手机型号进行优化</div>

      <div class="sub-title">收集情况：</div>
      <div>收集1次</div>

      <div class="sub-title">信息名称：</div>
      <div>设备型号</div>

      <div class="sub-title">使用目的：</div>
      <div>App质量保障</div>

      <div class="sub-title">使用场景：</div>
      <div>App启动与会议中针对手机型号进行优化</div>

      <div class="sub-title">收集情况：</div>
      <div>收集1次</div>

      <div class="sub-title">信息名称：</div>
      <div>MAC地址</div>

      <div class="sub-title">使用目的：</div>
      <div>App质量保障</div>

      <div class="sub-title">使用场景：</div>
      <div>App启动与会议中针对手机型号进行优化</div>

      <div class="sub-title">收集情况：</div>
      <div>收集1次</div>

      <div class="sub-title">信息名称：</div>
      <div>设备唯一识别码(OAID/IMEI/MEID/AndroidID/IDFA/OPENUDID/IDFV/出厂序列号/SIM卡IMSI)</div>

      <div class="sub-title">使用目的：</div>
      <div>App质量保障</div>

      <div class="sub-title">使用场景：</div>
      <div>App启动与会议中针对手机型号进行优化</div>

      <div class="sub-title">收集情况：</div>
      <div>收集1次</div>

      <div class="sub-title">信息名称：</div>
      <div>屏幕分辨率</div>

      <div class="sub-title">使用目的：</div>
      <div>App质量保障</div>

      <div class="sub-title">使用场景：</div>
      <div>App启动与会议中针对手机型号进行优化</div>

      <div class="sub-title">收集情况：</div>
      <div>收集1次</div>

      <div class="sub-title">信息名称：</div>
      <div>操作系统版本</div>

      <div class="sub-title">使用目的：</div>
      <div>App质量保障</div>

      <div class="sub-title">使用场景：</div>
      <div>App启动与会议中针对手机型号进行优化</div>

      <div class="sub-title">收集情况：</div>
      <div>收集1次</div>

      <div class="sub-title">信息名称：</div>
      <div>网络类型</div>

      <div class="sub-title">使用目的：</div>
      <div>App质量保障</div>

      <div class="sub-title">使用场景：</div>
      <div>App启动与会议中针对手机型号进行优化</div>

      <div class="sub-title">收集情况：</div>
      <div>收集1次</div>

      <div class="sub-title">信息名称：</div>
      <div>网络运营商类型</div>

      <div class="sub-title">使用目的：</div>
      <div>App质量保障</div>

      <div class="sub-title">使用场景：</div>
      <div>App启动与会议中针对手机型号进行优化</div>

      <div class="sub-title">收集情况：</div>
      <div>收集1次</div>

      <div class="sub-title">信息名称：</div>
      <div>已安装应用列表</div>

      <div class="sub-title">使用目的：</div>
      <div>第三方登录与分享时,需要判断是否已经安装需要使用的第三方应用</div>

      <div class="sub-title">使用场景：</div>
      <div>第三方登录与分享</div>

      <div class="sub-title">收集情况：</div>
      <div>收集1次</div>

      <div class="sub-title">信息名称：</div>
      <div>应用进程列表</div>

      <div class="sub-title">使用目的：</div>
      <div>App质量保障</div>

      <div class="sub-title">使用场景：</div>
      <div>App启动与会议中针对手机型号进行优化</div>

      <div class="sub-title">收集情况：</div>
      <div>收集1次</div>

      <div class="sub-title">信息名称：</div>
      <div>应用崩溃数据</div>

      <div class="sub-title">使用目的：</div>
      <div>App质量保障</div>

      <div class="sub-title">使用场景：</div>
      <div>App运行崩溃时</div>

      <div class="sub-title">收集情况：</div>
      <div>每次崩溃时收集1次</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'privacy',
  data () {
    return {
      isShow: false
    }
  },
  mounted () {
    setTimeout(() => {
      this.isShow = true
    }, 100)
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
#privacy
  margin .25rem
  font-size 0.14rem
  line-height 0.20rem
  text-align justify
  height auto
  h1
    font-weight bold
    font-size 0.16rem
  div
    text-indent 0.21rem
    margin .01rem 0
    &.title
      text-indent 0
      font-weight bold
      font-size 0.16rem
      margin 0.1rem 0rem
    .sub-title
      font-weight 500
      margin-top 0.08rem
    &.sub-p
      text-indent 0.59rem
    a
      color #000
      &:hover
        color #0982cb
</style>



// WEBPACK FOOTER //
// checklist.vue?b1d1bf4c